import * as Yup from 'yup'
export function loginvalidate(values) {
    return Yup.object().shape({
      username: Yup.string().required('This field is required'),
      password: Yup.string().required('This field is required'),
    });
}
